import { render, staticRenderFns } from "./ChartLegend.vue?vue&type=template&id=ad1cbb6c&"
import script from "./ChartLegend.vue?vue&type=script&lang=js&"
export * from "./ChartLegend.vue?vue&type=script&lang=js&"
import style0 from "./ChartLegend.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports